import React, { useEffect, useState } from 'react';

const InputTextSimple = (props) => {
    const [textVal, setTextVal] = useState(props.Val || '');

    // Update textVal when props.Val changes
    useEffect(() => {
        setTextVal(props.Val || '');
    }, [props.Val]);

    const lbl = (props.lbl != null) ? (
        <p className={props.lblCss}>{props.lbl}</p>
    ) : "";

    return (
        <>
            {lbl}
            <input
                type={props.Typ}
                className={props.Css}
                value={textVal}
                placeholder={props.placeholder}
                onChange={(e) => {
                    setTextVal(e.target.value);
                    props.settingFunc(e.target.value);
                }}
            />
        </>
    );
};

export default InputTextSimple;
